import './style.css';

const Loading = () => {
  return (
    <div className="loading-wrapper">
      <div className="loader"></div>
    </div>
  );
};

export default Loading;
